import { Pipe, PipeTransform } from '@angular/core';
import { CoverageTierDisplayTextMapping } from '../constants/common.constant';

@Pipe({ name: 'tierCoverage' })
export class TierCoveragePipe implements PipeTransform {
  public transform(s: string): string {
    return (CoverageTierDisplayTextMapping as Record<string, string>)[s];
  }
}
